import React, { SyntheticEvent, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box, styled, Typography } from '@mui/material';

type Props = {
	value: string | number;
	setValue: (value: string) => void;
	options: string[] | number[];
	// eslint-disable-next-line react/require-default-props
	label?: string;
	// eslint-disable-next-line react/require-default-props
	getOptionLabel?: (value: string) => string;
	// eslint-disable-next-line react/require-default-props
	freeSolo?: boolean;
	// eslint-disable-next-line react/require-default-props
	number?: boolean;
	// eslint-disable-next-line react/require-default-props
	renderOption?: (props: {}, value: string) => JSX.Element;
};

// hide number input arrows
const StyledInput = styled(TextField)`
	input[type='number']::-webkit-inner-spin-button,
	input[type='number']::-webkit-outer-spin-button {
		display: none;
	}
`;

export default ({
	value,
	setValue,
	options,
	label,
	number,
	...props
}: Props) => {
	const onChange = useCallback(
		(_: SyntheticEvent<Element, Event>, v: string) => setValue(v),
		[setValue]
	);

	const renderInput = useCallback(
		(params: {}) => (
			<StyledInput type={number ? 'number' : 'text'} {...params} />
		),
		[number]
	);

	const isOptionEqualToValue = useCallback(
		(opt: string, v: string) => opt === v || Number(opt) === Number(v),
		[]
	);

	return (
		<Box flexGrow={1} minWidth={170} maxWidth={250}>
			{label && (
				<Typography marginBottom={1} variant="subtitle2" color="text.secondary">
					{label}
				</Typography>
			)}
			<Autocomplete
				{...props}
				autoSelect
				filterSelectedOptions={false}
				isOptionEqualToValue={isOptionEqualToValue}
				disableCloseOnSelect={false}
				value={value as string}
				disablePortal
				disableClearable
				options={options as string[]}
				renderInput={renderInput}
				onChange={onChange}
			/>
		</Box>
	);
};
